import { useState, useRef, useEffect } from 'react';

import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Chip,
  ClickAwayListener,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import PerfectScrollbar from 'react-perfect-scrollbar';

import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';

import { getAllowedCourtSettings, getPlaces } from 'services/placeServices';

import { color, courtOptions, menuOptions } from 'constant/constant';
import { getCourtPlace, setCourtPlace } from 'helper/LocalStorage';
import { getFirstLetters } from 'helper/String';
import { getAllowedMerchantSettings } from 'services/merchantServices';
import { getMerchantLastRoute } from 'helper/MerchantRoutesStorage';

// ==============================|| COURT ||============================== //

const CourtSection = () => {
  const theme = useTheme();
  const customization = useSelector((state) => state.customization);
  const [court, setCourt] = useState(courtOptions.sort((a, b) => a.code.localeCompare(b.code)));
  const [selectedCourt, setSelectedCourt] = useState({});
  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);

  useEffect(() => {
    loadPlace()

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const isCourtAvailable = court.find(value => value.id == getCourtPlace().id);
    setSelectedCourt(isCourtAvailable || court[0]);
    sessionStorage.setItem('selectPlace', isCourtAvailable.id || court[0].id)
    setCourtPlace(isCourtAvailable || court[0])
  }, [court]);

  const loadPlace = async () => {
    let { data, error } = await getPlaces({
      isActive: true
    });
    if (error) { console.log(error) }
    if (data) {
      let menu = [...await getListMenu(), ...await getCourtListMenu()]
      let court = data.map((value) => ({
        id: value._id,
        name: value.name,
        code: getFirstLetters(value.name),
        merchantId: value.merchantId || '',
        allowedMenu: menu
          ? menu.find(item => item.merchantId ? (item.merchantId === value.merchantId) : item.placeId ? (item.placeId === value._id) : '')?.allowedMenu
          : [],
        title: menuOptions.find(v => v.value == value._id)?.label || getFirstLetters(value.name)
      }))

      localStorage.setItem("court_place", JSON.stringify(court))
    }
  }

  const getListMenu = async () => {
    let { data, error } = await getAllowedMerchantSettings()
    if (error) { console.log(error) }
    if (data) {
      return data
    }
  };

  const getCourtListMenu = async () => {
    let { data, error } = await getAllowedCourtSettings('')
    if (error) { console.log(error) }
    if (data) {
      return data
    }
  };

  // const handleToggle = (value) => {
  //   const path = window.location.pathname;
  //   let checkUrl = path.split('/');
  //   let newPath = ""
  //   if (checkUrl[2] === 'setting-profile') {
  //     checkUrl[1] = value.code
  //     newPath = checkUrl.join("/")
  //   } else {
  //     newPath = `/${value.code}/${checkUrl[2]}`
  //   }
  //   window.location.href = newPath;
  // }
  const handleToggle = (value) => {
    const currentPath = window.location.pathname;
    let currentParts = currentPath.split('/').filter(Boolean);
    sessionStorage.setItem('selectPlace', value.id)

    // special route handling if needed
    // if (currentParts[1] === 'setting-profile') {
    //   window.location.href = `/${value.code}/setting-profile`;
    //   return;
    // }
    if (currentParts[2] === 'setting-profile') {
      currentParts[1] = value.code
      window.location.href = currentParts.join("/")
      return;
    }

    const savedPath = getMerchantLastRoute(value.code);

    // console.log('here saved path', savedPath)

    if (savedPath) {
      window.location.href = savedPath;
      return;
    }

    window.location.href = `/${value.code}/dashboard`;
  };

  const handleClick = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleTest = () => {
    setOpen((prevOpen) => !prevOpen);
  }

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      {(court.length <= 3 && width > 768) && court.map((value) => {
        return (
          <Chip
            sx={{
              ml: 1.5,
              height: '30px',
              alignItems: 'center',
              borderRadius: '30px',
              transition: 'all .2s ease-in-out',
              borderColor: theme.palette.primary.light,
              backgroundColor: value.id === selectedCourt.id ? color.lightblue : null
            }}
            label={value.title}
            variant="outlined"
            clickable={value.id !== selectedCourt.id}
            onClick={() => value.id === selectedCourt.id ? true : handleToggle(value)}
            color="primary"
          />
        )
      })

      }

      {(court.length > 3 && width > 768) &&
        <>
          <Chip
            sx={{
              ml: 1.5,
              height: '30px',
              alignItems: 'center',
              borderRadius: '30px',
              transition: 'all .2s ease-in-out',
              borderColor: theme.palette.primary.light,
              backgroundColor: color.lightblue
            }}
            label={selectedCourt.title}
            variant="outlined"
            clickable={false}
            color="primary"
          />

          <Chip
            sx={{
              ml: 1.5,
              height: '30px',
              alignItems: 'center',
              borderRadius: '30px',
              transition: 'all .2s ease-in-out',
              borderColor: theme.palette.primary.light,
              backgroundColor: null
            }}
            label={'Select Court'}
            variant="outlined"
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleTest}
            onDelete={handleTest}
            deleteIcon={<ExpandMore />}
            color="primary"
          />
          <Popper
            placement='bottom-start'
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            popperOptions={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 10]
                  }
                }
              ]
            }}
          >
            {
              ({ TransitionProps }) => (
                <Transitions in={open} {...TransitionProps}>
                  <Paper>
                    <ClickAwayListener onClickAway={handleClick}>
                      <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                        <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(25vh)', overflowX: 'hidden' }}>
                          <Box>
                            <List
                              component="nav"
                              sx={{
                                width: 200,
                                backgroundColor: theme.palette.background.paper,
                                borderRadius: '10px',
                                [theme.breakpoints.down('md')]: {
                                  minWidth: '100%'
                                },
                                '& .MuiListItemButton-root': {
                                  mt: 0.5
                                }
                              }}
                            >
                              {court.filter((_, index) => index !== court.findIndex(value => value.id === selectedCourt.id)).map((value) => {
                                return (
                                  <ListItemButton
                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                    onPointerDown={(e) => {
                                      e.preventDefault(); // Prevents Safari from shifting focus away
                                      handleToggle(value);
                                    }}
                                  >
                                    <ListItemText primary={<Typography variant="body2">{value.title}</Typography>} />
                                  </ListItemButton>
                                )
                              })
                              }

                            </List>
                          </Box>
                        </PerfectScrollbar>
                      </MainCard>
                    </ClickAwayListener>
                  </Paper>
                </Transitions>
              )
            }
          </Popper>
        </>
      }

      {width <= 768 &&
        <>
          <Chip
            sx={{
              ml: 1.5,
              height: '30px',
              alignItems: 'center',
              borderRadius: '30px',
              transition: 'all .2s ease-in-out',
              borderColor: theme.palette.primary.light,
              backgroundColor: color.lightblue
            }}
            label={selectedCourt.title}
            variant="outlined"
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleTest}
            onDelete={handleTest}
            deleteIcon={<ExpandMore />}
            color="primary"
          />
          <Popper
            placement='bottom-start'
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            popperOptions={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 10]
                  }
                }
              ]
            }}
          >
            {
              ({ TransitionProps }) => (
                <Transitions in={open} {...TransitionProps}>
                  <Paper>
                    <ClickAwayListener onClickAway={handleClick}>
                      <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                        <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(25vh)', overflowX: 'hidden' }}>
                          <Box>
                            <List
                              component="nav"
                              sx={{
                                width: 200,
                                backgroundColor: theme.palette.background.paper,
                                borderRadius: '10px',
                                [theme.breakpoints.down('md')]: {
                                  minWidth: '100%'
                                },
                                '& .MuiListItemButton-root': {
                                  mt: 0.5
                                }
                              }}
                            >
                              {court.filter((_, index) => index !== court.findIndex(value => value.id === selectedCourt.id)).map((value) => {
                                return (
                                  <ListItemButton
                                    sx={{ borderRadius: `${customization.borderRadius}px` }}
                                    onPointerDown={(e) => {
                                      e.preventDefault(); // Prevents Safari from shifting focus away
                                      handleToggle(value);
                                    }}
                                  >
                                    <ListItemText primary={<Typography variant="body2">{value.title}</Typography>} />
                                  </ListItemButton>
                                )
                              })
                              }

                            </List>
                          </Box>
                        </PerfectScrollbar>
                      </MainCard>
                    </ClickAwayListener>
                  </Paper>
                </Transitions>
              )
            }
          </Popper>
        </>
      }

    </>
  );
};

export default CourtSection;
